module.exports = __webpack_public_path__ + "img/info.5fcab998.png";